import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
                <div className='sm:text-right pb-8 pl-4'>
                      <p className='text-4xl font-bold inline border-b-4 border-green-600'>
                        About
                      </p>
                </div>
                <div></div>
                </div>
                <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
                    <div className= 'sm:text-right text-4xl font-bold' >
                        <p>Welcome, I am Dubard, glad you made it here, have a look around.</p>
                    </div>
                    <div>
                        <p>A recent graduate with a Bachelor Degree in Computer Science. I have completed certificate courses in Web Development(Front-end, HTML,CSS). I have a basic knowledge of Javascript(ES6), React.JS, python and C++. I am currently interested in an Entry-Level Front-End web Development Job. I am also exploring the field of becoming a Junior Software Developer. I do have the tendencies of adapting to cultures and my environments quickly. I do play online Blitz Chess very often, I do calisthenics, and also I play Basketball oh I am a dog lover and a huge Boston Celtics fan or I would say Jayson Tatum. Would you like to share some fun facts about you and what you do ?</p>
                    </div>
                </div>
            </div>
         </div>
  )
}

export default About